import { Home, Newspaper, Menu, Smartphone, LayoutGrid } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface BottomNavigationProps {
  onMenuClick?: () => void;
  activeTab?: "home" | "news" | "profile" | "menu" | "prodotti" | "bacheca";
  variant?: "light" | "dark";
}

export const BottomNavigation = ({ onMenuClick, activeTab = "home", variant = "light" }: BottomNavigationProps) => {
  const navigate = useNavigate();

  const isDark = variant === "dark";

  const btnClass = (tab: string) =>
    `p-3 rounded-full transition-all duration-300 hover:scale-110 active:scale-90 group ease-out hover:-translate-y-0.5 ${activeTab === tab ? (isDark ? "bg-teal-500/20" : "bg-primary/10") : (isDark ? "hover:bg-white/10" : "hover:bg-muted")}`;

  const iconClass = (tab: string) =>
    `w-5 h-5 transition-all duration-300 group-hover:rotate-[-8deg] group-active:rotate-0 ${activeTab === tab ? (isDark ? "text-teal-400" : "text-primary") : (isDark ? "text-white/60 group-hover:text-white" : "text-muted-foreground group-hover:text-foreground")}`;

  return (
    <div className="fixed bottom-6 left-1/2 z-50" style={{ transform: 'translateX(-50%)', willChange: 'auto' }}>
      <nav 
        className={`flex items-center gap-2 backdrop-blur-lg px-6 py-3 rounded-full shadow-2xl border ${
          isDark 
            ? "bg-[#0a1628]/90 border-white/10" 
            : "bg-background/90 border-border/50"
        }`}
        style={{
          transform: 'perspective(1000px) rotateX(5deg)',
          boxShadow: isDark 
            ? '0 20px 60px -15px rgba(0, 0, 0, 0.3), 0 10px 25px -10px rgba(59, 130, 246, 0.3)'
            : '0 20px 60px -15px hsl(var(--foreground) / 0.15), 0 10px 25px -10px hsl(var(--primary) / 0.15)',
        }}
      >
        <button onClick={() => navigate("/news")} className={btnClass("news")}>
          <Newspaper className={iconClass("news")} />
        </button>
        <button onClick={() => navigate("/prodotti")} className={btnClass("prodotti")}>
          <Smartphone className={iconClass("prodotti")} />
        </button>
        <button onClick={() => navigate("/")} className={btnClass("home")}>
          <Home className={iconClass("home")} />
        </button>
        <button onClick={() => navigate("/bacheca")} className={btnClass("bacheca")}>
          <LayoutGrid className={iconClass("bacheca")} />
        </button>
        <button 
          onClick={onMenuClick}
          className={`p-3 rounded-full transition-all duration-300 hover:scale-110 active:scale-90 group ease-out hover:-translate-y-0.5 ${activeTab === "menu" ? (isDark ? "bg-teal-500/20" : "bg-primary/10") : (isDark ? "hover:bg-white/10" : "hover:bg-muted")}`}
        >
          <Menu className={`w-5 h-5 transition-all duration-300 group-hover:rotate-[-8deg] group-active:rotate-0 ${isDark ? "text-white/60 group-hover:text-white" : "text-muted-foreground group-hover:text-foreground"}`} />
        </button>
      </nav>
    </div>
  );
};